import React, { useEffect, useRef } from "react";
import TitreEtape from "./TitreEtape";
import ConfirmationEffacement from "./ConfirmationEffacement";
import { etatApercu, groupesApercu } from "./effacementDonnees";

const VERDICTS = {
  effacable: { ton: "succes", icone: "check-circle", libelle: "Effacement possible" },
  refuse: { ton: "alerte", icone: "ban", libelle: "Effacement impossible" },
  vide: { ton: "neutre", icone: "search", libelle: "Rien à effacer" },
};

const FICHES_CONSERVEES = {
  une: {
    titre: "1 fiche société conservée",
    texte: "Un autre compte l'utilise : seules les informations de cette personne en seront retirées.",
  },
  plusieurs: (nombre) => ({
    titre: `${nombre} fiches société conservées`,
    texte: "D'autres comptes les utilisent : seules les informations de cette personne en seront retirées.",
  }),
};

const fichesConservees = (nombre) => (nombre > 1 ? FICHES_CONSERVEES.plusieurs(nombre) : FICHES_CONSERVEES.une);

const ApercuEffacement = ({ apercu, envoiEnCours, onEffacer }) => {
  const titre = useRef(null);
  const etat = etatApercu(apercu);
  const verdict = VERDICTS[etat];

  useEffect(() => {
    titre.current?.focus();
  }, [apercu]);

  return (
    <>
      <section className="effacement__carte" aria-labelledby="titre-apercu">
        <header className="effacement__entete">
          <TitreEtape numero={2} id="titre-apercu" ref={titre}>
            Vérifier ce qui sera effacé
          </TitreEtape>
          <span className={`effacement__puce effacement__ton--${verdict.ton}`}>
            <i className={`fa fa-${verdict.icone}`} aria-hidden="true" />
            {verdict.libelle}
          </span>
        </header>
        <p className="effacement__adresse">
          <i className="fa fa-envelope" aria-hidden="true" />
          {apercu.email}
        </p>

        {etat === "refuse" && (
          <div className="effacement__message effacement__ton--alerte" role="alert">
            <i className="fa fa-ban" aria-hidden="true" />
            <div>
              <strong>Rien ne sera effacé.</strong>
              <p>{apercu.motifRefus}</p>
            </div>
          </div>
        )}

        {etat === "vide" && (
          <div className="effacement__vide">
            <i className="fa fa-search" aria-hidden="true" />
            <p>Aucune donnée trouvée pour cette adresse : il n'y a rien à effacer.</p>
            <small>La recherche porte sur l'adresse exacte, majuscules mises à part : vérifiez son orthographe.</small>
          </div>
        )}

        {etat === "effacable" && (
          <>
            <div className="effacement__groupes">
              {groupesApercu(apercu).map((groupe) => (
                <div className="effacement__groupe" key={groupe.titre}>
                  <h3>{groupe.titre}</h3>
                  <ul>
                    {groupe.lignes.map((ligne) => (
                      <li key={ligne.cle}>
                        <i className={`fa fa-${ligne.icone}`} aria-hidden="true" />
                        <span>{ligne.libelle}</span>
                        {ligne.valeur !== null && <span className="effacement__compte">{ligne.valeur}</span>}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            {apercu.fichesConservees > 0 && (
              <div className="effacement__message effacement__ton--encours">
                <i className="fa fa-building" aria-hidden="true" />
                <div>
                  <strong>{fichesConservees(apercu.fichesConservees).titre}</strong>
                  <p>{fichesConservees(apercu.fichesConservees).texte}</p>
                </div>
              </div>
            )}
          </>
        )}
      </section>

      {etat === "effacable" && (
        <ConfirmationEffacement email={apercu.email} envoiEnCours={envoiEnCours} onEffacer={onEffacer} />
      )}
    </>
  );
};

export default ApercuEffacement;
